// extracted by mini-css-extract-plugin
export var createdDate = "_jd-1";
export var divider = "_jd-2";
export var headerDivider = "_jd-3";
export var messagesCard = "_jd-0";
export var messagesContainer = "_jd-7";
export var messagesContainerWrapper = "_jd-4";
export var pointerCapturingButtonBoxes = "_jd-a";
export var showLeftPanelButton = "_jd-9";
export var showMoreButton = "_jd-c";
export var showMoreButtonContainer = "_jd-b";
export var summaryTitle = "_jd-6";
export var systemMessageCardWrapper = "_jd-d";
export var topButtons = "_jd-8";
export var withPadding = "_jd-5";